"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.confirmed.title': 'Pagamento Riuscito!',
    'payment.confirmed.message': 'Grazie per il tuo pagamento. La tua transazione è stata completata con successo.',
    'payment.confirmed.details': 'Dettagli Pagamento',
    'payment.confirmed.date': 'Data Pagamento',
    'payment.confirmed.paymentIntent': 'ID Intenzione Pagamento',
    'payment.confirmed.fetchError': 'Impossibile recuperare i dettagli del pagamento',
    'payment.confirmed.unknownProvider': 'Fornitore Sconosciuto',
    'payment.confirmed.accountUpgraded': 'Account Aggiornato con Successo',
    'payment.confirmed.accountUpgradedMessage': 'Il tuo account è stato aggiornato e le nuove funzionalità sono ora disponibili.',
    'payment.confirmed.nextSteps': 'Cosa Fare Dopo?',
    'payment.confirmed.nextStepsMessage': 'Ora puoi iniziare a utilizzare le tue funzionalità avanzate. Esplora la chat AI, crea avatar e gestisci la tua base di conoscenza.',
    'payment.confirmed.startChatting': 'Inizia a Chattare',
    'payment.confirmed.viewAccount': 'Visualizza Account',
    'payment.confirmed.backHome': 'Torna alla Home',
    'payment.confirmed.receiptInfo': 'Una ricevuta è stata inviata al tuo indirizzo email. Puoi anche scaricarla dalle impostazioni del tuo account.',
};
